import axios from 'axios';

export const client = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT || '',
});

export const setAcceptLanguage = locale => {
  client.defaults.headers.common['Accept-Language'] =
    locale === 'en' ? 'en-US' : locale;
};



// WEBPACK FOOTER //
// /app/apps/ms/src/services/HttpService.js